import React from "react";
import styles from "../Dashboard.module.css";

const ReportsCompliance = () => {
  return (
    <div className={styles.dashboard}>
      <main className={styles.main}>Reports Compliance</main>
    </div>
  );
};

export default ReportsCompliance;
